export default {
    approvalFlow: {
        cooperative: {
            delete: 'Delete',
            deactivate: 'Deactivate',
            activate: 'Activate',
            add: 'Add New Cooperative',
            addNewAgent:'Add New Agent/Union',
            editAgent: 'Edit Agent/Union',
            edit: 'Edit',
            cooperativeName: 'Cooperative Name',
            membershipPlan: 'Membership Plan',
            primaryContact: 'Primary Contact',
            agentUnionName:'Agent/Union Name',
            agentUnionDetails:'Agent/Union Details',
            agentUnionEmail:'Agent/Union Email',
            agentUnionPhoneNumber:'Agent/Union Phone Number',

            addAgent:'Add Agent/Union',
            unionAgents:'Unions/Agents',
            agent:'Agent',
            union:'Union',
            cooperativeExporter:'Cooperative/Exporter',

            firstName: 'First Name',
            lastName: 'Last Name',
            phoneNumber: 'Phone Number',
            email: 'Email',
            location: 'Location',
            businessInformation: 'Business Information',
            country: 'Country',
            provinceState: 'Province/State',
            regionDistrict: 'Region/District',
            villageTownCity: 'Village/Town/City',
            address: 'Address',
            interestedCommodities: 'Interested Commodities/Products',
            coffee: 'Coffee',
            cacao: 'Cacao',
            landRegistered: 'How much land will be registered? (in hectares)',
            userType: 'User Type',
            exporter: 'Exporter',
            cooperative: 'Cooperative',
            bothOfThem: 'Both of them',
            uploadLogo: 'Upload copy of Logo',
            uploadLogoButton: 'UPLOAD LOGO',
            enterHere: 'Enter here',
            select: 'Select',
            cooperativeNameRequired: 'Cooperative name is required',
            firstNameRequired: 'First name is required',
            emailRequired: 'Email is required',
            invalidEmail: 'Invalid email',
            required: 'Required',
            pleaseUploadValidImage: 'Please upload a valid image file',
            errorPreparingData: 'Error preparing data',
            cancel: 'Cancel',
            save: 'Save',
            update: 'Update',
            dueDiligenceReports: 'Due Diligence Reports',
            // List page translations
            listOfCooperatives: 'List of Cooperatives',
            addCooperatives: 'Add Cooperatives',
            loadingData: 'Loading data...',
            search: 'Search',
            type: 'Type',
            cooperativeTypeInformation: 'Cooperative Type Information',
            all: 'All',
            of: 'of',
            active: 'Active',
            unregistered: 'Unregistered',
            deactivated: 'Deactivated',
            view: 'View',
            confirmDelete: 'Confirm Delete',
            areYouSureDeleteCooperative: 'Are you sure you want to delete this cooperative?',
            updatedSuccessfully: 'Updated successfully',
            createdSuccessfully: 'Created successfully',
            errorFetchingCooperativeDetails: 'Error fetching cooperative details',
            errorSavingCooperative: 'Error saving cooperative',
            errorFetchingCooperativesData: 'Error fetching cooperatives data',
            cooperativeDeactivatedSuccessfully: 'Cooperative deactivated successfully',
            errorDeactivatingCooperative: 'Error deactivating cooperative',
            cooperativeDeletedSuccessfully: 'Cooperative deleted successfully',
            errorDeletingCooperative: 'Error deleting cooperative',
            noOfFarms: 'No. of Farms',
            cropsProducts: 'Crops/Products',
            status: 'Status',
            actions: 'Actions',
            cooperativeAndExporter: 'Cooperative + Exporter',
            cooperativeActivatedSuccessfully: 'Cooperative activated successfully',
            back: 'Back',
            commoditiesProducts: 'Cooperative Details',
            cooperativeEmail: 'Cooperative Email',
            cooperativePhoneNumber: 'Cooperative Phone Number',
            logo: 'Logo',
            advanced: 'Advanced',

            // Tooltips
            statusTT: 'Current operational state of the cooperative in the system (e.g., Active, Deactivated, Unregistered).',
            logoTT: 'Official image or symbol of Organization logo for branding on reports/QR pages.',
            cooperativeNameTT: 'The legal registered name of the cooperative, used in all compliance records and reports.',
            primaryContactTT: 'Contact name, email, phone.',
            locationTT: 'Filter by location text (country/province/city).',
            membershipPlanTT: 'The plan or agreement that outlines the terms and conditions of membership in the cooperative.',
            countryTT: 'The country where the cooperative is legally registered and operates. This helps align reports with national regulations.',
            provinceStateTT: 'The province or state where the cooperative is legally registered and operates. This helps align reports with regional regulations.',
            regionDistrictTT: 'The region or district where the cooperative is based. This helps ensure accurate community-level identification.',
            villageTownCityTT: 'The name of the local settlement (village, town, or city) where the cooperative is based. This ensures accurate community-level identification.',
            addressTT: 'The full physical or postal address of the cooperative. This should include street details, if available, for accurate referencing in reports.',
            interestedCommoditiesTT: 'Displays the product code and name associated with the report. This field helps users understand what product the report is related to.',
            userTypeTT: 'Filter results by Cooperative role/type.',
            overdueTimeLegend: 'Overdue time for DDS report: 20 days.',
            pendingComplianceLegend: 'DDS reports having farm issues with government database checks have status: Pending Compliance.',
        },  
    },
};